export default __webpack_public_path__ + "static/media/kar.0bfc6306.jpg";